import * as yup from 'yup';

export const validationSchema = yup.object({
  email: yup.string().required('Email is required.').email('Must be a valid email.'),
  name: yup.string().required('Name is required.'),
  question: yup.string().required('Question or comment is required.').max(2500, 'Max 2500 characters'),
  topicTermId: yup.string().required('Topic is required.'),
});
